/**
 * Lazy loader for Instagram embeds in blog posts.
 *
 * Instagram's embed.js is heavy and third-party, so it is never requested
 * until an embed nears the viewport, and never at all on posts without one.
 * Until it runs, the blockquote renders as a styled link card (see
 * snippets/eblog-instagram.liquid), which is also the permanent state when a
 * blocker or a deleted post stops the script working.
 */
(function () {
  var SRC = 'https://www.instagram.com/embed.js';
  var embeds = document.querySelectorAll('.eblog-ig__embed');
  if (!embeds.length) return;

  var requested = false;

  function process() {
    if (window.instgrm && window.instgrm.Embeds) {
      window.instgrm.Embeds.process();
    }
  }

  function load() {
    if (requested) return;
    requested = true;

    // Already on the page (a second post, or a theme app block)
    if (window.instgrm && window.instgrm.Embeds) {
      process();
      return;
    }

    var existing = document.querySelector('script[src="' + SRC + '"]');
    if (existing) {
      existing.addEventListener('load', process);
      return;
    }

    var script = document.createElement('script');
    script.src = SRC;
    script.async = true;
    script.addEventListener('load', process);
    document.body.appendChild(script);
  }

  if (!('IntersectionObserver' in window)) {
    load();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          observer.disconnect();
          load();
          return;
        }
      }
    },
    { rootMargin: '600px 0px' }
  );

  for (var i = 0; i < embeds.length; i++) observer.observe(embeds[i]);

  /**
   * Instagram sizes each iframe once, on process(). A width change after
   * that (rotate, resize) leaves it at the old width, so re-process on a
   * debounced resize.
   */
  window.addEventListener('resize', debounce(function () {
    if (requested) process();
  }, 250));
})();
